/* eslint-disable max-lines */
/* eslint-disable no-extra-parens */
import {
    BuildingOfficeIcon,
    ChatAltIcon,
    CogIcon,
    HeroEllipsisVerticalIcon,
    HeroRectangleGroupIcon,
    HeroShieldCheckIcon,
    HeroUserGroupIcon,
    NinchatQueueIcon,
    NinchatQueuesListIcon,
    TagIcon,
    UsersIcon,
} from 'components/Icon'

import {
    Dropdown, DropdownButtonNew, DropdownContent,
} from 'components/Dropdown'

import {
    dropdownsButtonsWrapper, list,
} from '../styles'

import Button from 'components/Button'
import {Icon} from 'components/Icon/types'
import React from 'react'
import Tooltip from 'components/Tooltip'
import {navigation} from 'navigation'
import permissionGuard from 'components/Navigation/helpers/PermissionGuard'
import {styled} from 'stitches/config'
import {
    useAppSelector,
} from 'hooks'
import {useTranslation} from 'react-i18next'

const StyledList = styled('ul', list)
const StyledDropdownButtonsWrapper = styled('div', dropdownsButtonsWrapper)

export const SideMenuRealmView = (): React.ReactElement => {
    const {t} = useTranslation()
    const {realm_id} = useAppSelector(({navigation: navigationState}) => navigation.route.params<'Realm'>(navigationState.routes[navigationState.position]))
    const hasViewRealmPermissions = permissionGuard.hasViewRealmPermissions()
    const hasViewRealmQueuePermissions = permissionGuard.hasViewRealmQueuePermissions()
    const hasViewRealmSitePermissions = permissionGuard.hasViewRealmSitePermissions()

    return (
        <StyledList>
            <li>
                <Dropdown>
                    <DropdownButtonNew caret={false} color='text' iconRight={HeroEllipsisVerticalIcon as unknown as Icon} />
                    <DropdownContent direction='left' >
                        <StyledDropdownButtonsWrapper>
                            <Button color='text' iconLeft={BuildingOfficeIcon} onPress={(): void => { navigation.push('Realm', {realm_id}) }} text={t('Organization overview')} />
                            {hasViewRealmPermissions ?
                                <>
                                    <Button
                                        color='text'
                                        iconLeft={UsersIcon}
                                        onPress={(): void => {
                                            navigation.push('Realm', {
                                                realm_id,
                                                tab: 'members',
                                            })
                                        }}
                                        text={t('Members')}
                                    />
                                    {hasViewRealmQueuePermissions ?
                                        <Button
                                            color='text'
                                            iconLeft={NinchatQueueIcon}
                                            onPress={(): void => {
                                                navigation.push('Realm', {
                                                    realm_id,
                                                    tab: 'queues',
                                                })
                                            }}
                                            text={t('Queues')}
                                        />
                                        : null}
                                    {hasViewRealmQueuePermissions ?
                                        <Button
                                            color='text'
                                            iconLeft={NinchatQueuesListIcon as unknown as Icon}
                                            onPress={(): void => {
                                                navigation.push('Realm', {
                                                    realm_id,
                                                    tab: 'group-queues',
                                                })
                                            }}
                                            text={t('Group Queues')}
                                        />
                                        : null}
                                    <Button
                                        color='text'
                                        iconLeft={HeroUserGroupIcon as unknown as Icon}
                                        onPress={(): void => {
                                            navigation.push('Realm', {
                                                realm_id,
                                                tab: 'channels',
                                            })
                                        }}
                                        text={t('Channel')}
                                    />
                                    <Button
                                        color='text'
                                        iconLeft={HeroShieldCheckIcon as unknown as Icon}
                                        onPress={(): void => {
                                            navigation.push('Realm', {
                                                realm_id,
                                                tab: 'permissions',
                                            })
                                        }}
                                        text={t('Permission groups')}
                                    />
                                    {hasViewRealmSitePermissions ?
                                        <Button
                                            color='text'
                                            iconLeft={HeroRectangleGroupIcon as unknown as Icon}
                                            onPress={(): void => {
                                                navigation.push('Realm', {
                                                    realm_id,
                                                    tab: 'sites',
                                                })
                                            }}
                                            text={t('Sites')}
                                        />
                                        : null}
                                    <Button
                                        color='text'
                                        iconLeft={TagIcon as unknown as Icon}
                                        onPress={(): void => {
                                            navigation.push('Realm', {
                                                realm_id,
                                                tab: 'tags',
                                            })
                                        }}
                                        text={t('Tags')}
                                    />
                                    <Button
                                        color='text'
                                        iconLeft={CogIcon}
                                        onPress={(): void => {
                                            navigation.push('Realm', {
                                                realm_id,
                                                tab: 'settings',
                                            })
                                        }}
                                        text={t('Settings')}
                                    />
                                    <Button
                                        color='text'
                                        iconLeft={ChatAltIcon}
                                        onPress={(): void => {
                                            navigation.push('Realm', {
                                                realm_id,
                                                tab: 'canned-messages',
                                            })
                                        }}
                                        text={t('Canned messages')}
                                    />
                                </>
                                : null}
                        </StyledDropdownButtonsWrapper>
                    </DropdownContent>
                </Dropdown>
            </li>
            <li><Button color='text' data-tooltip-id='overview' iconLeft={BuildingOfficeIcon} onPress={(): void => { navigation.push('Realm', {realm_id}) }} text='' />
                <Tooltip id='overview' position='right' singleLine>
                    {t('Organization overview')}
                </Tooltip>
            </li>
            {hasViewRealmPermissions ?
                <li>
                    <Button
                        color='text'
                        data-tooltip-id='members'
                        iconLeft={UsersIcon}
                        onPress={(): void => {
                            navigation.push('Realm', {
                                realm_id,
                                tab: 'members',
                            })
                        }}
                        text=''
                    />
                    <Tooltip id='members' position='right' singleLine>
                        {t('Members')}
                    </Tooltip>
                </li>
                : null}
            {hasViewRealmQueuePermissions ?
                <li>
                    <Button
                        color='text'
                        data-tooltip-id='queues'
                        iconLeft={NinchatQueueIcon}
                        onPress={(): void => {
                            navigation.push('Realm', {
                                realm_id,
                                tab: 'queues',
                            })
                        }}
                        text=''
                    />
                    <Tooltip id='queues' position='right' singleLine>
                        {t('Queues')}
                    </Tooltip>
                </li>
                : null}
            {hasViewRealmQueuePermissions ?
                <li>
                    <Button
                        color='text'
                        data-tooltip-id='group-queues'
                        iconLeft={NinchatQueuesListIcon as unknown as Icon}
                        onPress={(): void => {
                            navigation.push('Realm', {
                                realm_id,
                                tab: 'group-queues',
                            })
                        }}
                        text=''
                    />
                    <Tooltip id='group-queues' position='right' singleLine>
                        {t('Group Queues')}
                    </Tooltip>
                </li>
                : null}
            {hasViewRealmPermissions ?
                <li>
                    <Button
                        color='text'
                        data-tooltip-id='channels'
                        iconLeft={HeroUserGroupIcon as unknown as Icon}
                        onPress={(): void => {
                            navigation.push('Realm', {
                                realm_id,
                                tab: 'channels',
                            })
                        }}
                        text=''
                    />
                    <Tooltip id='channels' position='right' singleLine>
                        {t('Channels')}
                    </Tooltip>
                </li>
                : null }
            {hasViewRealmPermissions ?
                <li>
                    <Button
                        color='text'
                        data-tooltip-id='permissions'
                        iconLeft={HeroShieldCheckIcon as unknown as Icon}
                        onPress={(): void => {
                            navigation.push('Realm', {
                                realm_id,
                                tab: 'permissions',
                            })
                        }}
                        text=''
                    />
                    <Tooltip id='permissions' position='right' singleLine>
                        {t('Permission groups')}
                    </Tooltip>
                </li>
                : null }
            {hasViewRealmSitePermissions ?
                <li>
                    <Button
                        color='text'
                        data-tooltip-id='sites'
                        iconLeft={HeroRectangleGroupIcon as unknown as Icon}
                        onPress={(): void => {
                            navigation.push('Realm', {
                                realm_id,
                                tab: 'sites',
                            })
                        }}
                        text=''
                    />
                    <Tooltip id='sites' position='right' singleLine>
                        {t('Sites')}
                    </Tooltip>
                </li>
                : null}
            {hasViewRealmPermissions ?
                <li>
                    <Button
                        color='text'
                        data-tooltip-id='tags'
                        iconLeft={TagIcon as unknown as Icon}
                        onPress={(): void => {
                            navigation.push('Realm', {
                                realm_id,
                                tab: 'tags',
                            })
                        }}
                        text=''
                    />
                    <Tooltip id='tags' position='right' singleLine>
                        {t('Tags')}
                    </Tooltip>
                </li>
                : null }
            {hasViewRealmPermissions ?
                <li>
                    <Button
                        color='text'
                        data-tooltip-id='settings'
                        iconLeft={CogIcon}
                        onPress={(): void => {
                            navigation.push('Realm', {
                                realm_id,
                                tab: 'settings',
                            })
                        }}
                        text=''
                    />
                    <Tooltip id='settings' position='right' singleLine>
                        {t('Settings')}
                    </Tooltip>
                </li>
                : null}
            {hasViewRealmPermissions ?
                <li>
                    <Button
                        color='text'
                        data-tooltip-id='canned'
                        iconLeft={ChatAltIcon}
                        onPress={(): void => {
                            navigation.push('Realm', {
                                realm_id,
                                tab: 'canned-messages',
                            })
                        }}
                        text=''
                    />
                    <Tooltip id='canned' position='right' singleLine>
                        {t('Canned messages')}
                    </Tooltip>
                </li>
                : null }
        </StyledList>
    )
}
